import { IObject } from "@/models/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { SERVER_API_URL } from "src/config/constants";
import { closeModal } from "./modal-reducer";
import { refreshObjectsSearch } from "./object-search.reducer";
import { getConfig } from "./config-reducer";

const INITIAL_STATE = {
  loading: false,
  errorMessage: null as unknown as string,
  fetchSuccess: false,
  fetchFailure: false,
};

export type ObjectsCrudState = Readonly<typeof INITIAL_STATE>;

export const createObject = createAsyncThunk(
  "objects/create",
  async (params: IObject, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<boolean> = await axios.post(`${SERVER_API_URL}/api/objects`, params);
      dispatch(refreshObjectsSearch());
      dispatch(closeModal());
      dispatch(getConfig());
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editObject = createAsyncThunk(
  "authors/edit",
  async (params: IObject, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<boolean> = await axios.put(`${SERVER_API_URL}/api/objects`, params);
      dispatch(refreshObjectsSearch());
      dispatch(closeModal());
      dispatch(getConfig());
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteObject = createAsyncThunk(
  "authors/delete",
  async (id: number | undefined, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<boolean> = await axios.delete(`${SERVER_API_URL}/api/objects/${id}`);
      dispatch(refreshObjectsSearch());
      dispatch(closeModal());
      dispatch(getConfig());
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const objectsCrudSlice = createSlice({
  name: "post",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createObject.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(createObject.fulfilled, (state) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
        };
      })
      .addCase(createObject.rejected, (state) => {
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(editObject.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(editObject.fulfilled, (state) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
        };
      })
      .addCase(editObject.rejected, (state) => {
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteObject.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteObject.fulfilled, (state) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
        };
      })
      .addCase(deleteObject.rejected, (state) => {
        return {
          ...state,
          loading: false,
        };
      });
  },
});

export default objectsCrudSlice.reducer;
